import { render } from "./EditShippingMethod.vue?vue&type=template&id=23726a1d&scoped=true&ts=true"
import script from "./EditShippingMethod.vue?vue&type=script&lang=ts"
export * from "./EditShippingMethod.vue?vue&type=script&lang=ts"

import "./EditShippingMethod.vue?vue&type=style&index=0&id=23726a1d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23726a1d"]])

export default __exports__